module.exports = __webpack_public_path__ + "img/logo.1f6e1381.png";